import React from "react";
import '../../scss/mainPage.scss';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import TheHeader from "./comm/TheHeader";
import Swal from 'sweetalert';
import ApiHelper from "src/utils/api/api_helper";
import {
  CButton,
  CContainer,
  CCol,
  CRow,
  CCardBody,
  CCardHeader,
  CCardFooter,
} from "@coreui/react";
import { useHistory } from "react-router-dom";
import { setCorp, setTask } from "../../modules/main";
import { persistor } from "src/store";
import Error from "src/views/custRequest/comm/Error";
import { saveAs } from "file-saver";

var Agent = navigator.userAgent.toLowerCase();
// 카카오인앱 브라우저 접속 유무 판단
if(Agent.includes("kakao")){
  // 카카오인앱 브라우저 닫기
  window.location.href = "kakaotalk://inappbrowser/close";
  // 크롬으로 열기
  window.location.href = 'intent://'+window.location.href.replace(/https?:\/\//i,'')+'#Intent;scheme=http;package=com.android.chrome;end';  
}

const MainPage = (props) => {
  const { main } = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const [tasks, setTasks] = React.useState([]);
  const [forms, setForms] = React.useState([]);
  const ifKey = useLocation().pathname.substring(1);
  const param = { ifKey };
  const param2 = { corpNo: main.corpNo };
  const [corpInfo, setCorpInfo] = React.useState({
    corpNm: "",
    corpImgInfo: "",
  });
  const [isLoading, setIsLoading] = React.useState(true);
  const [showPopup, setShowPopup] = React.useState(false);
  const [taskNo, setTaskNo] = React.useState('');
  const [cntrYn, setCntrYn] = React.useState('');
  const [crerYn, setCrerYn] = React.useState('');
  const appUrl = `${process.env.REACT_APP_API_HOST}`;
  const [hashCorp, setHashCorp] = React.useState(false);
  const [fnrYnTxt, setFnrYnTxt] = React.useState('');
  
  const handleOnClick = async (e) => {
    await dispatch(setTask(e.target.dataset.taskNo, e.target.dataset.cntrYn, '0'));
    history.push(`/${main.corpNm}/1`);
  };

  // 지금융만 경력여부 선택 체크박스 추가
  const handleOnClickGfk = async (e) => {
    const { taskNo, cntrYn } = e.target.dataset;
    
    await setTaskNo(taskNo);
    await setCntrYn(cntrYn);
    await openPopup();
  };

  // 경력확인 팝업
  function openPopup() {
    setShowPopup(true);
  }

  function onStChange(e) {
    const { value } = e.target;

    setCrerYn(value);
  }

  async function closePopup() {
    await setCrerYn('');
    await setShowPopup(false);
  }

  const handleGoToNext = async () => {
    if(!crerYn) return Swal('경력 확인', '필수 입니다.', 'info');
    
    await dispatch(setTask(taskNo, cntrYn, '0', crerYn));
    history.push(`/${main.corpNm}/1`);
  };

  React.useEffect(() => {
    async function init() {
      await persistor.purge();
  
      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/corpInfo",
        param
      ).then(({ data }) => {
        if (data.status === "SUCCESS") {
          const result = data.data;
          const length = result.length;
          
          // 스카이블루에셋 내외국인 분리
          let hash = '';
          if(result[0].CORP_NO == '62'){
            const prvHashValue = main.hashValue;
              hash = main.hashValue == '' ? window.location.hash : prvHashValue;      
          }
          if (length > 0) {
            dispatch(
              setCorp({
                corpNo: String(result[0].CORP_NO),
                corpNm: result[0].IF_KEY,
                corpNm2: result[0].CORP_NM,
                corpBnrImg: result[0].LOGO_REAL_FILE_NM,
                hashValue: hash
              })
            );
            setCorpInfo({
              corpNm: result[0].CORP_NM,
              corpImgInfo: "",
            });
          } else {
            dispatch(
              setCorp({
                corpNo: "",
                corpNm: "",
              })
            );
          }
  
        }
      // let path = "/"+window.location.href.split('/')[3];

      window.history.pushState({}, null, '#init');
      window.history.pushState({}, null, props.location.pathname);
      window.onpopstate = function(e) {
        if( window.location.hash == "#init") {
          window.history.go(1);
        }
      }
  
        setIsLoading(false);
      });
    }
 
    init();
    
    return () => {
      setTasks([]);
      setForms([]);
    };
  }, []);

  // taskList
  React.useEffect(() => {
    if (main.corpNo !== "") { 
      ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/taskList",
        param2
      ).then(({ data }) => {
        if (data.status === "SUCCESS") {
          let taskList = data.data;

          // 스카이블루에셋 내외국인 분리
          if(main.corpNo == '62'){
            if(main.hashValue != ''){
              // #K -> 내국인 #F -> 외국인 / 해당 값은 무조건 대문자만 가능!
              taskList = taskList.filter((item)=>{
                if( (item.RMK == 'ALL') ||(item.RMK == main.hashValue)) {
                  return item;
                }
              })
              if(main.hashValue == '#F'){
                setFnrYnTxt('외국인');
              }else if(main.hashValue == '#K'){
                setFnrYnTxt('내국인');
              }

              if(taskList.length > 0){
                //페이지로딩 여부
                setHashCorp(true)
              }
            }else{
              taskList = [];
            }
          }else{
            setHashCorp(true)
          }

          setTasks(taskList);
        }
        setIsLoading(false);
      }).catch((err) => {
        console.error(err);
      });

      ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/formList",
        param2
      ).then(({ data }) => {
        if (data.status === "SUCCESS") {
          let formList = data.data;
          setForms(formList);
        }
        setIsLoading(false);
      }).catch((err) => {
        console.error(err);
      });
    }      
  }, [main.corpNo]);

  const handleDownloadOnClick = async (e) => {
    let encrpytFileNm = btoa(e.target.dataset.realFileNm);
    saveAs(`${appUrl}cust/request/download/sbmsDocForm?${encrpytFileNm}`, e.target.dataset.formFileNm);

  }

  return isLoading ? (
    <div>Loading...</div>
  ) : (main.corpNm && hashCorp) ? (
    <>
      <TheHeader />
      <div className="c-main">
        <CContainer>
          <h1>
            <b>EasyPaper</b>
          </h1>
          {/* 지금융만 문구 추가 */}
          {main.corpNm === 'gfk' || main.corpNm === 'GFK' ? 
          <>
            <h2>
              모바일 위촉 시스템
            </h2>
            <br/>
          </>
          : false}
          <h5>
            <b>
              서류작성 및 제출 간소화 시스템입니다.
              <br></br>아래에서 진행할 업무를 선택하세요.
            </b>
          </h5>
        </CContainer>
        {main.corpNm === 'global' || main.corpNm === 'GLOBAL' || main.corpNm === 'onef'
        ?
        <>
        <CCardBody>
          <CCardHeader>
            <h5><b>* 신규입사자</b></h5>
          </CCardHeader>
          {tasks.map((task) => {
            if (String(task.CNTR_YN) !== "0") {
              return (
                <CRow className="mb-2 mt-2" key={task.TASK_NO}>
                  <CCol xs="12">
                    <CButton
                      color="primary"
                      variant="outline"
                      block
                      data-task-no={task.TASK_NO}
                      data-cntr-yn={task.CNTR_YN}
                      onClick={handleOnClick}
                    >
                      {task.TASK_NM}
                    </CButton>
                  </CCol>
                </CRow>
              );
            } else {
              return null;
            }
          })}
          <CCardFooter className="text-left"></CCardFooter>
        </CCardBody>
        <CCardBody>
          <CCardHeader>
            <h5><b>* 자격추가자</b></h5>
            {main.corpNm === 'global' || main.corpNm === 'GLOBAL' 
            ?
            <h6 className="text-left text-danger"><b>{corpInfo.corpNm} 등록된 설계사만 신청 가능합니다.</b></h6>
            : 
            <h6 className="text-left text-danger"><b>당사에 생보 또는 손보 기 위촉된 설계사에 한해 자격추가 신청 가능합니다.</b></h6>
            }
          </CCardHeader>
          {tasks.map((task) => {
            if (String(task.CNTR_YN) === "0") {
              return (
                <CRow className="mb-2 mt-2" key={task.TASK_NO}>
                  <CCol xs="12">
                    <CButton
                      color="primary"
                      variant="outline"
                      block
                      data-task-no={task.TASK_NO}
                      data-cntr-yn={task.CNTR_YN}
                      onClick={handleOnClick}
                    >
                      {task.TASK_NM}
                    </CButton>
                  </CCol>
                </CRow>
              );
            } else {
              return null;
            }
          })}
          <CCardFooter>
          </CCardFooter>
        </CCardBody>
        </>
        : main.corpNm === 'gfk' || main.corpNm === 'GFK' 
        ?
        <>
        <CCardBody>
          <CCardHeader>
            <h6 className="text-left text-danger"><b>* 위촉진행</b></h6>
          </CCardHeader>
          {tasks.map((task) => {
            return (
              <CRow className="mb-2 mt-2" key={task.TASK_NO}>
                <CCol xs="12">
                  <CButton
                    color="primary"
                    variant="outline"
                    block
                    data-task-no={task.TASK_NO}
                    data-cntr-yn={task.CNTR_YN}
                    onClick={handleOnClickGfk}
                  >
                    {task.TASK_NM}
                  </CButton>
                </CCol>
              </CRow>
            );
          })}
          <CCardFooter>
          </CCardFooter>
        </CCardBody>
        <CCardBody>
          <CCardHeader>
            <h6 className="text-left text-danger"><b>* 필수첨부서류양식</b></h6>
          </CCardHeader>
          {forms.slice(0,3).map((form) => {
            return (
              <CRow className="mb-2 mt-2" key={form.FORM_NO}>
                <CCol xs="12">
                  <CButton
                    color="primary"
                    variant="outline"
                    block
                    data-form-file-nm={form.FORM_FILE_NM}
                    data-real-file-nm={form.REAL_FILE_NM}
                    onClick={handleDownloadOnClick}
                  >
                    {form.FORM_NM}
                  </CButton>
                </CCol>
              </CRow>
            );
          })}
          <CCardFooter>
          </CCardFooter>
        </CCardBody>
        <CCardBody>
          <CCardHeader>
            <h6 className="text-left text-danger"><b>* 기타서류양식</b></h6>
          </CCardHeader>
          {forms.slice(3,5).map((form) => {
            return (
                <CRow className="mb-2 mt-2" key={form.FORM_NO}>
                  <CCol xs="12">
                    <CButton
                        color="primary"
                        variant="outline"
                        block
                        data-form-file-nm={form.FORM_FILE_NM}
                        data-real-file-nm={form.REAL_FILE_NM}
                        onClick={handleDownloadOnClick}
                    >
                      {form.FORM_NM}
                    </CButton>
                  </CCol>
                </CRow>
            );
          })}
          <CCardFooter>
          </CCardFooter>
        </CCardBody>
        </>
        : main.corpNm === 'megainfo' || main.corpNm === 'MEGAINFO' 
        ?
        <>
        <CCardBody>
          <CCardHeader>
          </CCardHeader>
          {tasks.map((task) => {
            return (
              task.TASK_NO === 112 ?
              <CRow className="mb-2 mt-2 fc-btn" key={task.TASK_NO}>
                <CCol xs="12">
                  <CButton
                    color="primary"
                    variant="outline"
                    block
                    data-task-no={task.TASK_NO}
                    data-cntr-yn={task.CNTR_YN}
                    onClick={handleOnClick}
                  >
                    {task.TASK_NM}
                  </CButton>
                </CCol>
              </CRow>
              :
              <CRow className="mb-2 mt-2" key={task.TASK_NO}>
                <CCol xs="12">
                  <CButton
                    color="primary"
                    variant="outline"
                    block
                    data-task-no={task.TASK_NO}
                    data-cntr-yn={task.CNTR_YN}
                    onClick={handleOnClick}
                  >
                    {task.TASK_NM}
                  </CButton>
                </CCol>
              </CRow>
            );
          })}
          <CCardFooter>
          </CCardFooter>
        </CCardBody>
        </>
        :
        <>
        <CCardBody>
          <CCardHeader>
            {main.corpNm === 'sky' ? <h5><b>* {fnrYnTxt}용 *</b></h5> :''}
          </CCardHeader>
          {tasks.map((task) => {
            return (
              <CRow className="mb-2 mt-2" key={task.TASK_NO}>
                <CCol xs="12">
                  <CButton
                    color="primary"
                    variant="outline"
                    block
                    data-task-no={task.TASK_NO}
                    data-cntr-yn={task.CNTR_YN}
                    onClick={handleOnClick}
                  >
                    {task.TASK_NM}
                  </CButton>
                </CCol>
              </CRow>
            );
          })}
          <CCardFooter>
          </CCardFooter>
        </CCardBody>
        </>
        }
      </div>
      {showPopup &&
      <div className="layer-popup">
        <div className="box-popup popup-sign">
          <button
            className="popup-close"
            onClick={closePopup}
            type="button"
          >
            {' '}
          </button>
          <div className="popup-title">경력 확인</div>
          <div className="popup-contents">
            <span className="txt-label">경력여부를 선택해 주세요.</span>
            <div className="inline-label"></div>
            <fieldset className="radio-fileset">
            <div className="radio-inline">
              <label className="component-radio type-default">
                <input type="radio" name="crerYn" value="1"
                  onChange={(e) => onStChange(e)}
                  checked={crerYn === '1'} />
                <i />
                <div className="text-label">경력</div>
              </label>
              <label className="component-radio type-default">
                <input type="radio" name="crerYn" value="0"
                onChange={(e) => onStChange(e)}
                checked={crerYn === '0'} />
                <i />
                <div className="text-label">신입</div>
              </label>
              {main.corpNm === 'gfk' || main.corpNm === 'GFK'  ?
                <label className="component-radio type-default">
                  <input type="radio" name="crerYn" value="2"
                         onChange={(e) => onStChange(e)}
                         checked={crerYn === '2'} />
                  <i />
                  <div className="text-label">최초등록</div>
                </label>
              : false}
            </div>
            </fieldset>
          </div>
          <div className="popup-footer">
            <button className="btn-footer" type="button" onClick={() => closePopup()}>
              닫기
            </button>
            <button className="btn-footer type-solid" type="button" onClick={handleGoToNext}>
              확인
            </button>
          </div>
        </div>
      </div>}
    </>
  ) : (
    <Error />
  );
};

export default MainPage;
